import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {NsNotificationService} from "../../../../service/api/ns-notification.service";
import {NsNotificationStatusEnum} from "../../../../enum/ns-notification-status-enum.enum";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {Sorting} from "../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'mvs-example',
    templateUrl: './notification-statistics.component.html',
    standalone: false
})
export class NotificationStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {


    pendingNotification: number = 0;
    processedNotification: number = 0;
    deletedNotification: number = 0;
    errorNotification: number = 0;

    notificationHistoryWidget: WidgetData;
    notificationTypeWidget: WidgetData;
    notificationChannelWidget: WidgetData;
    recentlySentNotificationsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        protected notificationService: NsNotificationService,
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'Notification Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.getTotalNotification();
        this.refreshNotificationHistoryWidget();
        this.refreshNotificationTypeWidget();
        this.refreshNotificationChannelWidget();
        this.refreshRecentlySentNotifications();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/ns/config']);
    }


    getTotalNotification() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['notificationStatus'],
            [new ObjectRequestListAttribute('notificationStatus', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.notificationService.groupBy(objectRequestList).subscribe(res => {

            this.overviewDto = [
                { label: 'Pending Notification', value: 0 },
                { label: 'Processed Notification', value: 0 },
                { label: 'Deleted Notification', value: 0 },
                { label: 'Error Notification', value: 0 }
            ];

            for (let entry of res.entries) {
                if (entry['notificationStatus'] === NsNotificationStatusEnum.pending) {
                    this.overviewDto.find(item => item.label === 'Pending Notification').value = entry['notificationStatus_count'];
                } else if (entry['notificationStatus'] === NsNotificationStatusEnum.processed) {
                    this.overviewDto.find(item => item.label === 'Processed Notification').value = entry['notificationStatus_count'];
                } else if (entry['notificationStatus'] === NsNotificationStatusEnum.deleted) {
                    this.overviewDto.find(item => item.label === 'Deleted Notification').value = entry['notificationStatus_count'];
                } else if (entry['notificationStatus'] === NsNotificationStatusEnum.error) {
                    this.overviewDto.find(item => item.label === 'Error Notification').value = entry['notificationStatus_count'];
                }
            }

        });
    }

    refreshNotificationHistoryWidget() {
        this.notificationHistoryWidget = WidgetFactory.createWidget(
            'ns.notification.overview.notification.history.widget',
            'Notification History',
            'history.chart',
            'list',
            'entity.groupBy',
            'ns.NsNotification',
            WidgetDataParam.create("fieldCategory", "notificationStatus"),
            WidgetDataParam.create("fieldCategoryCount", "notificationStatus_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.notificationHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["notificationStatus", "createdDate"],
            [new ObjectRequestListAttribute("notificationStatus", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshNotificationTypeWidget() {
        this.notificationTypeWidget = WidgetFactory.createWidgetGroupBy(
            'ns.notification.overview.notification.type.widget',
            'Notification Type',
            'category',
            'entity.groupBy',
            'ns.NsNotificationType',
            'group',
            'group_count',
            this.filterCriteria,
            'group',
            'Anzahl');
    }

    refreshNotificationChannelWidget() {
        this.notificationChannelWidget = WidgetFactory.createWidgetGroupBy(
            'ns.notification.overview.notification.channel.widget',
            'Notification Channels',
            'category',
            'entity.groupBy',
            'ns.NsNotificationTypeChannelType',
            'channelType',
            'channelType_count',
            this.filterCriteria,
            'channelType',
            'Anzahl');
    }

    refreshRecentlySentNotifications() {
        this.recentlySentNotificationsWidget = WidgetFactory.createWidgetTableEntityBasicQl('ns.notification.overview.recently.sent.notification.new', 'Recently Sent Notification', 'ns.NsNotification', this.filterCriteriaForQuery ?? [], [new Sorting('e.createdDate', false)]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
